import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../App';
import { Loader2 } from 'lucide-react';

const ADMIN_EMAILS = ['thisisradas@gmail.com'];

export default function ProtectedRoute({ children, requiredType }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (loading) return;

    if (!user) {
      navigate('/auth', { state: { from: location.pathname } });
      return;
    }

    // Admins bypass all role gates — they can hit any protected page so they
    // can moderate/fix data without swapping accounts.
    const isAdmin = user.user_type === 'admin' || (user.email && ADMIN_EMAILS.includes(user.email.toLowerCase()));

    if (requiredType === 'admin' && !isAdmin) {
      navigate('/');
      return;
    }

    if (requiredType && requiredType !== 'admin' && user.user_type !== requiredType && !isAdmin) {
      navigate('/');
      return;
    }

    setIsChecking(false);
  }, [user, loading, requiredType, navigate, location]);

  if (loading || isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-accent" />
      </div>
    );
  }

  return children;
}
